import { render, staticRenderFns } from "./PersonalCreate.vue?vue&type=template&id=009f0ca0&scoped=true"
import script from "./PersonalCreate.vue?vue&type=script&lang=js"
export * from "./PersonalCreate.vue?vue&type=script&lang=js"
import style0 from "./PersonalCreate.vue?vue&type=style&index=0&id=009f0ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009f0ca0",
  null
  
)

export default component.exports